<template>
  <control-wrapper
    v-bind="controlWrapper"
    :styles="styles"
    :isFocused="isFocused"
    :appliedOptions="appliedOptions"
  >
    <v-input
      :error-messages="control.errors"
      :disabled="!control.enabled"
      :id="control.id + '-input'"
      :persistent-hint="persistentHint()"
      :hint="control.description"
      :required="control.required"
      @focus="isFocused = true"
      @blur="isFocused = false"
    >
      <v-container v-bind="vuetifyProps('v-container')" class="pa-0">
        <v-row v-bind="vuetifyProps('v-row')">
          <v-col>
            <v-label
              :for="control.id + '-input'"
              v-bind="vuetifyProps('v-label')"
              >{{ computedLabel }}</v-label
            ></v-col
          >
        </v-row>

        <v-item-group
          :mandatory="!!control.data"
          v-bind="vuetifyProps('v-item-group')"
          :value="control.data"
          @change="onChange"
        >
          <v-row v-bind="vuetifyProps('v-row')">
            <v-col
              v-for="o in control.options"
              :key="o.value"
              class="shrink"
              v-bind="vuetifyProps('v-col')"
            >
              <v-item :value="o.value" v-slot="{ active, toggle }">
                <v-img
                  :alt="t(o.label, o.label)"
                  :src="
                    active
                      ? appliedOptions['on-image'][`${o.value}`]
                      : appliedOptions['off-image'][`${o.value}`]
                  "
                  v-bind="vuetifyProps('v-img')"
                  @click="toggle"
                >
                  <v-label v-if="o.label" :value="active">{{
                    t(o.label, o.label)
                  }}</v-label>
                </v-img>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </v-container>
    </v-input>
  </control-wrapper>
</template>

<script lang="ts">
import {
  and,
  ControlElement,
  isOneOfEnumControl,
  JsonFormsRendererRegistryEntry,
  optionIs,
  rankWith,
} from '@jsonforms/core';
import {
  rendererProps,
  RendererProps,
  useJsonFormsOneOfEnumControl,
} from '@jsonforms/vue2';
import {
  ControlWrapper,
  useVuetifyControl,
  useTranslator,
} from '@jsonforms/vue2-vuetify';
import { defineComponent } from 'vue';
import {
  VItem,
  VItemGroup,
  VLabel,
  VContainer,
  VRow,
  VCol,
  VImg,
  VInput,
} from 'vuetify/lib';

const controlRenderer = defineComponent({
  name: 'oneof-image-group-control-renderer',
  components: {
    ControlWrapper,
    VLabel,
    VItemGroup,
    VItem,
    VContainer,
    VRow,
    VCol,
    VImg,
    VInput,
  },
  props: {
    ...rendererProps<ControlElement>(),
  },
  setup(props: RendererProps<ControlElement>) {
    const t = useTranslator();

    return {
      ...useVuetifyControl(useJsonFormsOneOfEnumControl(props), (value) =>
        value !== null ? value : undefined
      ),
      t,
    };
  },
});

export default controlRenderer;

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(
    20,
    and(isOneOfEnumControl, optionIs('format', 'radio-image'))
  ),
};
</script>
